/** @jsxImportSource @emotion/react */

import { ColorNames } from "../../../theme";
import CardContainer from "./CardContainer";
import SkeletonTypography from "../../Skeletons/components/SkeletonTypography";

const SkeletonCard = () => {
  return (
    <CardContainer borderColor={ColorNames.LIGHTGREY}>
      <SkeletonTypography variant="textLarge" />
      <br />
      <SkeletonTypography variant="textLarge" />
      <SkeletonTypography variant="textLarge" />
      <SkeletonTypography variant="textLarge" />
    </CardContainer>
  );
};

export default SkeletonCard;
